// Diverse collection of last names for candidate generation

export const LAST_NAMES: string[] = [
  // Common English surnames
  'Smith',
  'Johnson',
  'Williams',
  'Brown',
  'Jones',
  'Miller',
  'Davis',
  'Wilson',
  'Anderson',
  'Thomas',
  'Taylor',
  'Moore',
  'Jackson',
  'Martin',
  'Thompson',
  'White',
  'Harris',
  'Clark',
  'Lewis',
  'Robinson',
  'Walker',
  'Hall',
  'Young',
  'Allen',
  'King',
  'Wright',
  'Scott',
  'Green',
  'Baker',
  'Adams',
  'Nelson',
  'Hill',
  'Campbell',
  'Mitchell',
  'Roberts',
  'Carter',
  'Phillips',
  'Evans',
  'Turner',
  'Parker',

  // Hispanic surnames
  'Garcia',
  'Rodriguez',
  'Martinez',
  'Hernandez',
  'Lopez',
  'Gonzalez',
  'Perez',
  'Sanchez',
  'Ramirez',
  'Torres',
  'Flores',
  'Rivera',
  'Gomez',
  'Diaz',
  'Reyes',
  'Cruz',
  'Morales',
  'Ortiz',
  'Gutierrez',
  'Chavez',
  'Ramos',
  'Vargas',
  'Castillo',
  'Fernandez',
  'Ruiz',

  // German surnames
  'Mueller',
  'Schmidt',
  'Schneider',
  'Fischer',
  'Weber',
  'Meyer',
  'Wagner',
  'Becker',
  'Schulz',
  'Hoffman',
  'Koch',
  'Richter',
  'Klein',
  'Wolf',
  'Schroeder',
  'Neumann',
  'Schwarz',
  'Zimmermann',
  'Braun',
  'Krueger',

  // French surnames
  'Dubois',
  'Laurent',
  'Bernard',
  'Moreau',
  'Lefevre',
  'Simon',
  'Michel',
  'Leroy',
  'Roux',
  'David',
  'Bertrand',
  'Morel',
  'Fournier',
  'Girard',
  'Bonnet',
  'Lambert',
  'Fontaine',
  'Rousseau',
  'Vincent',
  'Chevalier',

  // Italian surnames
  'Rossi',
  'Russo',
  'Ferrari',
  'Romano',
  'Colombo',
  'Ricci',
  'Marino',
  'Greco',
  'Bruno',
  'Gallo',
  'Conti',
  'DeLuca',
  'Costa',
  'Mancini',
  'Barbieri',
  'Fontana',
  'Santoro',
  'Marini',
  'Rinaldi',
  'Caruso',

  // Scandinavian surnames
  'Johansson',
  'Lindberg',
  'Eriksson',
  'Larsson',
  'Berg',
  'Olsson',
  'Persson',
  'Nilsson',
  'Gustafsson',
  'Pettersson',
  'Jonsson',
  'Jansson',
  'Hansen',
  'Pedersen',
  'Andersen',
  'Nielsen',
  'Christensen',
  'Larsen',
  'Sorensen',
  'Rasmussen',

  // Polish surnames
  'Kowalski',
  'Nowak',
  'Wisniewski',
  'Wojcik',
  'Kowalczyk',
  'Kaminski',
  'Lewandowski',
  'Zielinski',
  'Szymanski',
  'Wozniak',
  'Dabrowski',
  'Kozlowski',
  'Jankowski',
  'Mazur',
  'Kwiatkowski',

  // Russian surnames
  'Ivanov',
  'Petrov',
  'Sidorov',
  'Kuznetsov',
  'Popov',
  'Sokolov',
  'Lebedev',
  'Kozlov',
  'Novikov',
  'Morozov',
  'Volkov',
  'Alekseev',
  'Fedorov',
  'Mikhailov',
  'Nikolaev',

  // South Asian surnames
  'Patel',
  'Singh',
  'Kumar',
  'Sharma',
  'Gupta',
  'Shah',
  'Mehta',
  'Joshi',
  'Reddy',
  'Rao',
  'Nair',
  'Menon',
  'Iyer',
  'Khan',
  'Ali',

  // Korean surnames
  'Kim',
  'Park',
  'Choi',
  'Jung',
  'Kang',
  'Cho',
  'Yoon',
  'Jang',
  'Lim',
  'Han',

  // Japanese surnames
  'Tanaka',
  'Yamamoto',
  'Suzuki',
  'Watanabe',
  'Ito',
  'Nakamura',
  'Kobayashi',
  'Yamada',
  'Saito',
  'Kato',
  'Yoshida',
  'Sasaki',
  'Yamaguchi',
  'Matsumoto',
  'Inoue',

  // Chinese surnames
  'Wang',
  'Zhang',
  'Liu',
  'Chen',
  'Yang',
  'Huang',
  'Zhao',
  'Wu',
  'Zhou',
  'Xu',
  'Sun',
  'Ma',
  'Zhu',
  'Hu',
  'Lin',

  // Portuguese/Brazilian surnames
  'Santos',
  'Ferreira',
  'Oliveira',
  'Costa',
  'Silva',
  'Pereira',
  'Almeida',
  'Carvalho',
  'Rodrigues',
  'Gomes',
  'Martins',
  'Araujo',
  'Melo',
  'Ribeiro',
  'Barros',

  // Irish surnames
  'Murphy',
  'Kelly',
  'Sullivan',
  'Walsh',
  'OBrien',
  'Byrne',
  'Ryan',
  'OConnor',
  'ONeill',
  'McCarthy',
  'OReilly',
  'Doyle',
  'Lynch',
  'Murray',
  'Quinn',

  // Greek surnames
  'Papadopoulos',
  'Papadakis',
  'Georgiou',
  'Nikolaou',
  'Konstantinou',
  'Dimitriou',
  'Ioannou',
  'Christodoulou',
  'Alexiou',
  'Stavros',

  // Middle Eastern surnames
  'Hassan',
  'Ahmed',
  'Mohammed',
  'Ibrahim',
  'Khalil',
  'Nasser',
  'Habib',
  'Farouk',
  'Rashid',
  'Mahmoud',

  // African surnames
  'Okonkwo',
  'Mensah',
  'Osei',
  'Asante',
  'Diallo',
  'Toure',
  'Ndiaye',
  'Traore',
  'Kamara',
  'Conteh',

  // Additional diverse surnames
  'Reed',
  'Cook',
  'Morgan',
  'Bell',
  'Bailey',
  'Rivera',
  'Cooper',
  'Richardson',
  'Cox',
  'Howard',
  'Ward',
  'Torres',
  'Peterson',
  'Gray',
  'James',
  'Watson',
  'Brooks',
  'Kelly',
  'Sanders',
  'Price',
]
